import React, { useRef } from 'react'
import classNames from 'classnames'
import { Form, Input, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { safeboxClient } from 'myNet'
import { useDispatch } from 'react-redux'
import LanguageSwitcher from 'components/LanguageSwitcher'
import styles from '../style.module.scss'
import XIcon from '@/assets/images/icon-expired-closed-hover.svg'
import CheckIcon from '@/assets/images/icon-check-24.svg'
import editIcon from '@/assets/images/icon-pencil-24.svg'

const GeneralRender = (props) => {
  const {
    messageApi,
    userName,
    setIsEditingEmail,
    isEditingEmail,
    isGlobal,
    isSamlUser,
    renderProfilePhoto,
  } = props
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const emailRef = useRef(null)

  const handleSaveEmail = async () => {
    console.log('handleSaveEmail - ')
    try {
      const res = await safeboxClient.put(`/v1/users/me/name`, {
        name: emailRef.current.getFieldValue('name'),
      })
      console.log('res - ', res)

      if (res?.data?.code === 200) {
        messageApi.success(t('appConfig.result.successSaveName'))
        setIsEditingEmail(false)
        dispatch({
          type: 'user/SET_USER_NAME',
          payload: { name: emailRef.current.getFieldValue('name') },
        })
      }
    } catch (error) {
      console.log('error - ', error)
      messageApi.error(t('appConfig.settings.failedSaveEmail'))
    }
  }

  const inputSuffix = () => {
    if (isEditingEmail) {
      return (
        <div>
          <Button
            type="text"
            icon={<img src={XIcon} alt="close" />}
            onClick={() => {
              setIsEditingEmail(false)
              emailRef.current.resetFields()
            }}
          />
          <Button type="text" icon={<img src={CheckIcon} alt="save" />} onClick={handleSaveEmail} />
        </div>
      )
    }

    return (
      <div>
        <Button
          type="text"
          icon={<img src={editIcon} alt="edit" />}
          onClick={() => setIsEditingEmail(true)}
        />
      </div>
    )
  }

  const formAttrs = {
    initialValues: { name: userName },
    ref: emailRef,
    className: classNames(styles.form),
    colon: false,
  }

  return (
    <div className={classNames(styles.tabItem, styles.generalContent)}>
      <div className={classNames(styles.LanguageContent)}>
        <span>{t('topBar.profileMenu.language')}</span>
        <div className="menu-language">
          <LanguageSwitcher country />
        </div>
      </div>

      {isGlobal() && (
        <div className={classNames(styles.AccountContent)}>
          <span className={classNames(styles.title)}>{t('appConfig.settings.account')}</span>
          <div className={classNames(styles.profilePhotoContent)}>
            <span className={classNames(styles.profilePhotoLabel)}>
              {t('appConfig.settings.profilePhoto')}
            </span>
            {/* 숨겨진 파일 input */}

            {renderProfilePhoto()}
          </div>
          {/* SAML 사용자는 IdP가 이름 source-of-truth — 이름 폼만 차단.
              프로필 사진은 IdP 관리 영역 외이므로 SAML 사용자도 변경 허용. */}
          {!isSamlUser && (
            <Form {...formAttrs}>
              <Form.Item name="name" label={t('appConfig.settings.fullName')}>
                <Input
                  className={classNames(styles.input)}
                  disabled={!isEditingEmail}
                  suffix={inputSuffix()}
                />
              </Form.Item>
            </Form>
          )}
        </div>
      )}
    </div>
  )
}

export default GeneralRender
